import React, {useState, Fragment, useEffect} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import DropDown2 from "../../../Generic/dropDown2";
import CheckBox from "../../../PageLayout/CheckBox";
import FeatureCreatorNewActions from "../../../FeatureCreator/FeatureCreatorNewActions";
import {getFeaturesExcludedObject} from "../../wizardFunctions";

const WizardPopupEditGroupClickFeatureSelect = (props) => {

  const {featureGroups, loadFeatures, resetFeatures, loadingFeatures, enabledFeatures} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {clickOnLogic} = wizardPopupState;

  const [groupOpened, setGroupOpened] = useState(false);
  const [featureOpened, setFeatureOpened] = useState(false);

  const changeClickOnLogic = (newLogic) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {clickOnLogic: Object.assign({}, clickOnLogic, newLogic)}
    })
  }

  const onGroupSelect = (groupName) => {
    if (!(clickOnLogic && clickOnLogic.groupName && (clickOnLogic.groupName === groupName))) {
      changeClickOnLogic({groupName, feature: null});
    }
    setGroupOpened(false);
  }

  const onFeatureSelect = (value, newFeature) => {
    if (!(clickOnLogic && clickOnLogic.feature && (clickOnLogic.feature.featureDefinitionId === newFeature.featureDefinitionId))) {
      changeClickOnLogic({feature: getFeaturesExcludedObject(newFeature)});
    }
    setFeatureOpened(false);
  }

  const allGroups = featureGroups.map(group => ({text: group.groupName, value: group.groupName}));
  const allFeatures = enabledFeatures.map(feat => {
    return {...feat, text: feat.name, value: feat.name}
  });

  const checked = clickOnLogic && clickOnLogic.enabled;
  const groupName = clickOnLogic && clickOnLogic.groupName ? clickOnLogic.groupName : "";
  const feature = clickOnLogic && clickOnLogic.feature ? clickOnLogic.feature : null;

  useEffect(() => {
    if (groupName) {
      loadFeatures(groupName, null, false);
    }
    return () => {
      resetFeatures();
    }
  }, [groupName])

  return (
    <div className="fc-inst__select">
      <CheckBox type={"tiny"}
                checked={checked}
                text={"Click on Feature"}
                onChecked={() => changeClickOnLogic({enabled: !checked})} />
      {/*<span className="generic-popup-title">Click on Feature:</span>*/}
      {checked ? (
        <Fragment>
          {!featureGroups.length ? <div className="ui-loader ui-loader--small"/> : (
            <div className={"fc-inst__select relative wizard-popup__block" + (groupOpened ? " select2--active" : "")}>
              <div className="select2-value wizard-popup__block-input" onClick={() => setGroupOpened(true)}>
                {clickOnLogic && clickOnLogic.groupName ? clickOnLogic.groupName : ""}
              </div>
              {groupOpened ? (
                <DropDown2 selected={groupName}
                           items={allGroups}
                  // items={this.state.featureList}
                           onClickOutside={() => setGroupOpened(false)}
                           onSelect={onGroupSelect}
                           useVirtualizedList={true}
                           sort={false}
                           wide={true}/>
              ) : null}
            </div>
          )}
          {loadingFeatures ? <div className="ui-loader ui-loader--small"/> : (
            <div className={"fc-inst__select relative wizard-popup__block" + (featureOpened ? " select2--active" : "")}>
              <div className="select2-value wizard-popup__block-input" onClick={() => setFeatureOpened(true)}>
                {feature ? feature.name : ""}
              </div>
              {featureOpened ? (
                <DropDown2 selected={feature ? {...feature, text: feature.name, value: feature.name} : null}
                           items={allFeatures}
                  // items={this.state.featureList}
                           onClickOutside={() => setFeatureOpened(false)}
                           onSelect={onFeatureSelect}
                           useVirtualizedList={true}
                           sort={false}
                           wide={true}/>
              ) : null}
            </div>
          )}
        </Fragment>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup, wizardPopupItem, wizardPopupType} = store.wizardState;
  const {featuresGroups} = store.projectScopeNew;
  let {enabledFeatures, loadingFeatures} = store.featuresCreatorNew;

  return {
    wizardPopupGroup,
    wizardPopupItem,
    wizardPopupType,
    featureGroups: featuresGroups,
    enabledFeatures,
    loadingFeatures,
  };
};

const mapDispatchToProps = {
  loadFeatures: FeatureCreatorNewActions.loadOnlyEnabledFeatures,
  resetFeatures: FeatureCreatorNewActions.resetFeatures,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupEditGroupClickFeatureSelect)
)
